<div class="gb-dialog-header">
  <h1>
    {{ dialogData.title | translate }}
  </h1>
</div>

<div class="gb-dialog-content">
  <p [innerHTML]="dialogData.body | translate"></p>

  @if (dialogData.note) {
    <p class="note">
      <mat-icon>information-circle</mat-icon>
      <span [innerHTML]="dialogData.note | translate | gbSafe: 'trustedHtml'"></span>
    </p>
  }
</div>
<div class="gb-flex-button-container gb-confirm-dialog-actions-container">
  <button mat-dialog-close mat-stroked-button>
    {{ cancelButtonText | translate }}
  </button>
  <button [mat-dialog-close]="true" mat-flat-button>
    {{ confirmButtonText | translate }}
  </button>
</div>
